import { useEffect } from "react";
import { ecommerceDataForProject } from "lib/enhancedEcommerce";
import { pushToDataLayer } from "components/front/layout/GoogleTagManager";
import { ExhibitionProject } from "interfaces/front/business";

export const useViewProject = (project: ExhibitionProject) => {
  useEffect(() => {
    const ecommerceData = ecommerceDataForProject(project);
    pushToDataLayer(ecommerceData);
  }, []);
};
